(ns app.front.view.group.admin.form-schemas.declarations
  (:require [app.domain.party-role.model :as role-model]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.table :as ui-table]
            [app.front.view.group.admin.subs :as gas]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.href :as href]
            [core.front.icons :as i]
            [re-frame.core-instrumented :as rf]))


(rf/reg-event-fx ::remove-declaration-config
  (fn [_ [_ declaration-id]]
    {:comm/command {:command    :group/remove-declaration-config
                    :method     :post
                    :data       {:declaration-id declaration-id}
                    :on-success [::entities/apply-changes]
                    :notify     {:success :declaration-config.admin/delete-success}}}))


(defn declaration-section []
  (let [group-id (<sub [::gas/group-id])
        lang     (<sub [:language])
        tr       (<sub [:tr])]
    (when group-id
      [:section
       [:div.flex.justify-between.items-center.mb-6
        [:h2.m-0 (tr [:declaration-config.admin/list-heading])]
        (cc/button {:kind :tertiary
                    :href (href/href :view/group.admin.declaration-editor {:group-id       group-id
                                                                           :declaration-id "new"})
                    :icon i/plus}
                   (tr [:add]))]
       [:div.w-full.xl:w-2-3
        [:p
         (tr [:declaration-config.admin/list-guide])
         (cc/link {:href (href/href :view/group.admin.config {:group-id group-id})}
                  (tr [:declaration-config.admin/list-guide-link]))
         "."]]
       [:div.w-full.xl:w-2-3
        [ui-table/modern-responsive-table
         {:items              (<sub [::gas/declaration-configs])
          :tr                 tr
          :row-class-override "lg:items-center hover:bg-ui-blue-10"
          :empty-placeholder  [:p (tr [:declaration-config.admin/no-configs])]
          :cols               [[:declaration-config/name
                                #(cc/link {:href (href/href :view/group.admin.declaration-editor {:group-id       group-id
                                                                                                  :declaration-id (:db/id %)})}
                                          (:declaration-config/name %))
                                {}]
                               [:declaration-config/party-role
                                #(role-model/party-role-name (:declaration-config/party-role %) lang)
                                {}]
                               [""
                                (fn [declaration]
                                  [ui/modal-confirmation-button
                                   {:tr                  tr
                                    :trigger-button-text (tr [:remove])
                                    :trigger-button-opts {:kind :tertiary
                                                          :size :small}
                                    :on-yes-click        #(>evt [::remove-declaration-config (:db/id declaration)])}
                                   (tr [:declaration-config.admin/confirm-removal]
                                       [(:declaration-config/name declaration)])])
                                {:flex "none"}]]}]]])))
